/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { isStringNullOrEmpty } from '../../../../utils';
import { IMapBalloonResponse, IVehiclePlotResponse, IVehiclePlotWebsubsResponse } from '../../../core/models';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { IEVBatteryDataResponse } from './../../../core/models/responses';

@Injectable({
  providedIn: 'root'
})
export class EVMockDataService {
  private readonly _evMockLocalStorageName = 'ev_plot_mock';

  constructor(private readonly _localStorage: LocalStorageService) {}

  mockEVBatteryData<T extends IVehiclePlotResponse | IVehiclePlotWebsubsResponse>(responsePlots: T[]): T[] {
    const localStorageValue = this._getLocalStorageValue();
    if (isStringNullOrEmpty(localStorageValue)) {
      return responsePlots;
    }

    try {
      const mockEVData = this._parseMockData(localStorageValue);

      return responsePlots.map(plot => {
        const mockedVehicle = mockEVData.find(mockVehicle => mockVehicle.name === plot.vnme);
        if (mockedVehicle) {
          const mockedBatteryData = this._getMockEVbatteryData(mockedVehicle);
          plot.EVBatteryData = mockedBatteryData;
        }
        return plot;
      });
    } catch (e) {
      return responsePlots;
    }
  }

  mockEVBatteryDataForBalloon<T extends IMapBalloonResponse>(balloon: T): T {
    const localStorageValue = this._getLocalStorageValue();
    if (isStringNullOrEmpty(localStorageValue)) {
      return balloon;
    }

    try {
      const mockEVData = this._parseMockData(localStorageValue);
      const mockedVehicle = mockEVData.find(mockVehicle => mockVehicle.name === balloon.VehicleName);

      if (mockedVehicle) {
        const mockedBatteryData = this._getMockEVbatteryData(mockedVehicle);
        balloon.EVBatteryData = mockedBatteryData;
      }
      return balloon;
    } catch (e) {
      return balloon;
    }
  }

  private _getLocalStorageValue() {
    return this._localStorage.getItem(this._evMockLocalStorageName);
  }

  private _parseMockData(evMockDataCookie: string): any[] {
    return JSON.parse(evMockDataCookie) as {
      name: string;
      batteryLastUpdateTime: string;
      batteryPercentage: number;
      lastChargingStartTime: string;
      chargingState: boolean;
    }[];
  }

  private _getMockEVbatteryData(mockedVehicle: any): IEVBatteryDataResponse {
    const mockedBatteryData = {
      BatteryLastUpdateTime: mockedVehicle.batteryLastUpdateTime,
      BatteryPercentage: mockedVehicle.batteryPercentage,
      LastChargingStartTime: mockedVehicle.lastChargingStartTime,
      ChargingState: mockedVehicle.chargingState
    };

    return mockedBatteryData;
  }
}
